export const PropertyOwnerFilterKey = {
  Type: 'definition.propertyType',
  State: 'state.status',
  Location: 'location.address.region',
} as const;
export type PropertyOwnerFilterKey = (typeof PropertyOwnerFilterKey)[keyof typeof PropertyOwnerFilterKey];
export const PROPERTY_OWNER_FILTER_KEYS = [
  PropertyOwnerFilterKey.Type,
  PropertyOwnerFilterKey.State,
  PropertyOwnerFilterKey.Location,
] as const;

export const PropertyAdminFilterKey = {
  ...PropertyOwnerFilterKey,
  VerificationOwner: 'verification.owner',
  DocumentStatus: 'documents.status',
  ModerationFlag: 'moderation.hasContactFlag',
} as const;
export type PropertyAdminFilterKey = (typeof PropertyAdminFilterKey)[keyof typeof PropertyAdminFilterKey];
export const PROPERTY_ADMIN_FILTER_KEYS = [
  PropertyAdminFilterKey.Type,
  PropertyAdminFilterKey.State,
  PropertyAdminFilterKey.Location,
  PropertyAdminFilterKey.VerificationOwner,
  PropertyAdminFilterKey.DocumentStatus,
  PropertyAdminFilterKey.ModerationFlag,
] as const;
